module.exports = __webpack_public_path__ + "img/T6-A-xh_01.b0b3f39a.png";